import { Helmet } from "react-helmet-async"
import React from "react"
import { Container, createStyles, Text, List, Title, Stack } from "@mantine/core"
import { PageTitle } from "../../shared/ui/PageTitle"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  container: {
    paddingTop: "4rem",
    paddingBottom: "4rem",

    [theme.fn.smallerThan("md")]: {
      paddingTop: "3rem",
      paddingBottom: "3rem",
    },

    [theme.fn.smallerThan("xs")]: {
      paddingTop: "1.5rem",
      paddingBottom: "1.5rem",
    },
  },
}))

// ----------------------------------------------------------------------

export function UseCookiesPage(): React.JSX.Element {
  const { classes } = useStyles()
  const url = new URL(window.location.href)

  return (
    <>
      <Helmet>
        <title>
          Использование куки
        </title>
        <meta property="og:title" content="Использование куки"/>

        <meta name="description"
              content="Использование куки на сайте Body Coach"/>
        <meta property="og:description"
              content="Использование куки на сайте Body Coach"/>

        <meta property="og:url" content={url.href}/>
        <link rel="canonical" href={url.href}/>
        <meta property="og:site_name" content={url.host}/>
        <meta name="robots" content="index, follow"/>

        <meta name="keywords"
              content="куки, куки боди коч, использование куки боди коуч, cookies body coach"/>
      </Helmet>

      <Container size="lg" className={classes.container}>
        <PageTitle title="Использование куки"/>

        <Stack>
          <Title size="h2">Как &#34;Центр&#34; использует Cookie?</Title>
          <Text>
            Партнерская программа учебного центра BODY COACH позволяет нашим студентам стать нашими
            партнерами и начать зарабатывать на продаже обучающих курсов.
          </Text>
        </Stack>

        <Stack mt="xl">
          <Title size="h2">Что такое Cookie?</Title>
          <Text>
            В целом это печенье. Но не в нашем случае. Cookie — это фрагмент данных сайта, на который вы зашли и который
            сохраняется на вашем компьютере.
          </Text>
        </Stack>

        <Stack mt="xl">
          <Title size="h2">Какие Cookie мы используем и с какой целью?</Title>
          <Text>
            Мы используем несколько разных типов cookie:
          </Text>
          <List type="ordered" mb="xl" spacing="md">
            <List.Item>
              Cookie для статистики: мы используем несколько систем для сбора статистики — нам важно знать, как
              нас читают. На основе этих данных мы понимаем размер нашей аудитории, а также что мы делаем правильно и
              что неправильно. Мы осуществляем сбор статистики через партнеров — Google Analytics, Yandex Metrika и
              Mediascope (бывший TNS).
            </List.Item>
            <List.Item>
              Реклама: мы используем системы показа рекламы (Google DFP и AdFox) для того, чтобы показывать вам
              контекстную рекламу, которая бы соответствовала вашим интересам.
            </List.Item>
            <List.Item>
              Игры: в некоторых играх и игровых механиках мы используем Cookie, чтобы хранить информацию об их
              прохождении и о результатах.
            </List.Item>
          </List>
        </Stack>

        <Stack mt="xl">
          <Title size="h2">Что делать, если вы не хотите использовать Cookie?</Title>
          <Text>
            Вы можете отключить их в настройках безопасности вашего браузера. Важно понимать, что настройки нужно
            применить во всех браузерах, которыми вы пользуетесь (на компьютере и в телефоне). В случае если вы решите
            отключить cookiе, имейте в виду, что часть функций сайта перестанут быть вам доступны или могут работать
            непредсказуемо.
          </Text>
        </Stack>

      </Container>
    </>
  )
}
